@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.passenger.voiceassistant

import com.narbase.letsgo.dto.DtoName
import com.narbase.letsgo.router.EndPoint
import com.narbase.letsgo.web.dto.config.SipExtensionDto
import com.narbase.letsgo.web.models.voiceassistant.VoiceAssistantTransferReason

object TransferVoiceAssistantToCallCenterEndpoint :
    EndPoint<TransferVoiceAssistantToCallCenterEndpoint.Request, TransferVoiceAssistantToCallCenterEndpoint.Response>() {
    class Request(
        val sessionId: String?,
        @Suppress("NON_EXPORTABLE_TYPE") val reason: DtoName<VoiceAssistantTransferReason>,
    )

    class Response(
        val sipExtension: SipExtensionDto?,
        val phoneNumber: String?,
    )
}
